import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { promotionService } from "../services/promotion.service";
import { PromotionListDetails } from "../models/response/PromotionListResponse";
import { CMSContainer } from "../../../components/ui/CMSContainer";
import { SupportedLanguages } from "../../../models/constants/supportedLanguages";
import { useLanguage } from "../../../config/localization/LanguageProvider";


export function PromotionDetails() {
    const { pageUrl } = useParams<{ pageUrl: string }>();
    const [promotion, setPromotion] = useState<PromotionListDetails | null>(null);
    const [loading, setLoading] = useState(true);

    const { language: languageCode } = useLanguage();

    useEffect(() => {
        if (pageUrl) {
            loadPromotion(pageUrl);
        }
    }, [pageUrl]);

    const loadPromotion = async (url: string) => {
        setLoading(true);
        try {
            const res = await promotionService.getPromotionByPageUrl(url);

            if (res.isSuccess && res.data?.details?.length) {
                setPromotion(res.data.details[0]);
            }
        } catch (error) {
            console.error("Error loading promotion:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen bg-[#0b0b21] text-white">
                Loading...
            </div>
        );
    }

    if (!promotion) {
        return (
            <div className="flex justify-center items-center h-screen bg-[#0b0b21] text-white">
                No promotion found.
            </div>
        );
    }
    const htmlDescription = languageCode === SupportedLanguages.Hindi
        ? promotion.detaileddescriptionhindi
        : promotion.detaileddescription;

    return (
        <div className="min-h-screen bg-[#0b0b21] text-white pb-10">
            <div className="container mx-auto px-4 py-6">
                <div className="bg-[#0b0b21]">
                    <CMSContainer html={htmlDescription ?? ""} />
                </div>
            </div>
        </div>
    );
}